// src/components/WhySection.js
import React from "react";
import {
    ShieldCheck,
    FileCheck2,
    ClipboardCheck,
    Timer,
    Users,
    Layers
} from "lucide-react";

// Data array for dynamic rendering
const whyus = [
    {
        icon: ShieldCheck,
        text: "100% transparent fee structure"
    },
    {
        icon: FileCheck2,
        text: "Clear mandate process"
    },
    {
        icon: ClipboardCheck,
        text: "High accuracy in documentation"
    },
    {
        icon: Timer,
        text: "Fast turnaround times"
    },
    {
        icon: Users,
        text: "Personalised support for families"
    },
    {
        icon: Layers,
        text: "One-stop solution for complex cases"
    }
];

const WhySection = () => {
    return (
        <>
            {/* [Why Work With Us] */}
            <section className="py-16 px-6 md:px-12 lg:px-20 bg-[#CDE9DC]">
                <div className="max-w-5xl mx-auto">

                    <h2 className="text-3xl font-serif font-semibold text-[var(--text-primary)] mb-10 text-center">
                        Why Work With Us
                    </h2>

                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-6">

                        {whyus.map((item, index) => {
                            const Icon = item.icon;

                            return (
                                <div
                                    key={index}
                                    className="flex flex-row items-center gap-4 p-5 rounded-xl border border-[var(--border)] bg-white shadow-sm text-left"
                                >
                                    <Icon className="w-7 h-7 text-[var(--color-primary)]" />
                                    <p className="text-[var(--text-primary)]">
                                        {item.text}
                                    </p>
                                </div>

                            );
                        })}

                    </div>
                </div>
            </section>
        </>
    );
};

export default WhySection;
